import moment from 'moment';

// Lightweight Notification entity wrapper with PascalCase fields only.
// Corresponds to WaveWise.WebApp.Models.Responses.NotificationItem (in-app channel).
export default class Notification {
  constructor(data) {
    // Expect data to have PascalCase fields:
    // Id, CreateTime, NotificationType, Parameters, RenderedText, IsRead
    this.Id = data.Id;
    this.NotificationType = data.NotificationType;
    this.Parameters = data.Parameters || {};
    this.RenderedText = data.RenderedText || null;
    this.RenderedTitle = data.RenderedTitle || null;
    this.IsRead = data.IsRead || false;

    // Handle timestamp fields with moment.js
    // Accepts a raw UTC string from the API or an existing moment object (e.g. when re-constructing)
    if (data.CreateTime !== undefined) {
      this.CreateTime = (data.CreateTime === null) ? null
        : moment.isMoment(data.CreateTime) ? data.CreateTime
        : moment.utc(data.CreateTime);
    }
  }

  // Return formatted local time string for display
  getFormattedCreateTime() {
    return this.CreateTime ? this.CreateTime.local().format('L LTS') : '';
  }

  // Return the best display text for the notification body
  getDisplayText() {
    return this.RenderedText || this.NotificationType || '';
  }

  // Return the best display title for the notification
  getDisplayTitle() {
    return this.RenderedTitle || '';
  }

  // Return the notification type display string
  getTypeDisplay() {
    return this.NotificationType || '';
  }
}
